import React from "react";
import Navbar from "./Component/Navbar";
import Page11 from "./Component/Footer";
import { Outlet } from "react-router-dom";
import Footer from "./Component/Footer";
import { Container } from "reactstrap";
import { useQuery } from "@tanstack/react-query";
import MenuService from "../../services/MenuService";


const MainLayout = ({ children }) => {
  const { isLoading, error, data } = useQuery({
    queryKey: ["menu-tree"],
    queryFn: () => MenuService.getList(),
  });
  console.log("🚀 ~ MainLayout ~ data:", data)

  // Filter by menuTypeName === "header"
  const headerMenus =
    data?.filter((menu) =>
      menu.menuTypes?.some((mt) => mt.name === "Header")
    ) || [];

  const footerMenus =
    data?.filter((menu) =>
      menu.menuTypes?.some((mt) => mt.name === "Footer")
    ) || [];
  return (
    <div>
      <Navbar headerMenus={headerMenus} />
      <main>
        <Outlet /> {/* This renders the child route */}
      </main>
      <Container fluid className="" style={{ background: "#7D178F" }}>

        <Container
          style={{
            width: window.innerWidth < 500 ? "100%" : "75%",
          }}
        >

          <Footer footerMenus={footerMenus} />
        </Container>
        <div className="position-relative ">

          <div
            className="position-absolute "
            style={{
              width: 0,
              height: 0,
              borderLeft: "clamp(60px, 4vw, 150px) solid transparent",
              borderRight: "clamp(60px, 5vw, 150px) solid transparent",
              borderBottom: "clamp(100px, 3vh, 200px) solid #ff4d1d",
              bottom: 0,
              left: 0,
            }}
          />
        </div>

      </Container>
    </div>
  );
};

export default MainLayout;

